// Types
import type { UserFields_hashtags } from 'api/auth/types/UserFields';
import { GetStoreBySlug_store_socialMedia } from 'api/store/types/GetStoreBySlug';
// Components
import AboutStore from 'components/Athlete/About/About';
import { showToast } from 'components/common/Toast/Toast';
// Helpers
import { getEnvLink } from 'helpers/routes';
// Ui3
import Modal from 'ui3/Modal/Modal';
import Text from 'ui3/Text/Text';
import Button from 'ui3/Button/Button';
// Styles
import styles from './AboutModal.module.scss';

type AboutModalProps = {
  open: boolean;
  onClose: () => void;
  storeName: string;
  bioText: string;
  hashtags: UserFields_hashtags[];
  links: GetStoreBySlug_store_socialMedia[];
  slug: string;
};

const AboutModal = ({
  open,
  onClose,
  storeName,
  bioText,
  hashtags,
  links,
  slug,
}: AboutModalProps) => {
  const handleShare = async () => {
    const sharePathname = `${getEnvLink()}/${slug}`;

    try {
      await navigator.clipboard.writeText(sharePathname);

      showToast({
        message: 'Copied',
        autoClose: 1000,
      });
    } catch (error) {
      showToast({
        message: 'Could not copy text',
        type: 'error',
        autoClose: 1000,
      });
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="medium"
      className={styles.modal}
      showCloseIcon={false}
      blockScroll={false}
    >
      <div className={styles.content}>
        <div className={styles.modalHeader}>
          <Text variant="h6" className={styles.title}>
            {storeName}
          </Text>
          <Button
            variant="secondary"
            subVariant="text"
            size="small"
            icon="close"
            onClick={onClose}
            aria-label="Close"
            className={styles.closeButton}
          />
        </div>
        <div className={styles.scrollableContent}>
          <AboutStore
            bioText={bioText}
            hashtags={hashtags}
            links={links}
            showFullBio={true}
          />
          <Button
            variant="secondary"
            size="medium"
            icon="share"
            iconPosition="left"
            onClick={handleShare}
            className={styles.shareButton}
          >
            Share Profile
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AboutModal;
